import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Label from './Label'

function ErrorLabel({ error, showStatus, statusProps, ...rest }) {
  const { t } = useTranslation()
  let errMsg

  if (!error) { return null }

  if (typeof error === 'string')
    errMsg = error
  else if (typeof error === 'object' && error.tStr)
    errMsg = t(error.tStr)

  return (
    <Label key={1} v='body1' bold color='error' {...rest}>
      {`${!error.status || !showStatus ? '' : error.status + ': '}${errMsg || ''}`}
    </Label>
  )
}

ErrorLabel.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string, 
    PropTypes.object
  ]),
  showStatus: PropTypes.bool,
  statusProps: PropTypes.object,
}

ErrorLabel.defaultProps = {
  showStatus: true,
  statusProps: {},
}

export default ErrorLabel